import { A } from '@solidjs/router';
import type { JSX } from 'solid-js';
import { t } from '../i18n';
import { DONATE_BADGE_PLACEHOLDER } from '../lib/donateBadge';
import { orgHref } from '../lib/org';
import { DonateBadgeSnippet } from './DonateBadgeSnippet';
import { buttonClass } from './ui/Button';

// The maintainer inbox with nothing in it (arc 101 slice 11, plan doc 05) — and
// the growth loop, which is the only reason this is a component rather than one
// `<EmptyState/>` line.
//
// An empty inbox is not a dead end: donors reach a project through its
// "accept donations" switch (per repo, in that repo's settings) and through the
// badge its README carries. So the empty state links to the first and hands over
// the second — with the owner/repo left as a PLACEHOLDER, because this surface is
// account-wide and a maintainer with several public repos should not be nudged
// toward whichever one we picked for them. The repo's own settings panel hands
// over the same snippet with its own name already in it.

export function DonationsInboxEmpty(): JSX.Element {
  return (
    <div class="empty-state donations-empty" role="status">
      <p class="empty-state__message">{t('donations.received_empty')}</p>
      <p class="empty-state__message">{t('donations.received_empty_how')}</p>
      <A class={buttonClass({ variant: 'outline', size: 'sm' })} href={orgHref('/repos')}>
        {t('donations.received_empty_cta')}
      </A>
      <DonateBadgeSnippet slug={DONATE_BADGE_PLACEHOLDER} class="donations-empty__badge" />
    </div>
  );
}
